// localStorage helpers for the access token. Centralised so the storage key
// lives in exactly one place. SSR-safe guards in case the module ever runs
// outside a browser (e.g. during a future test setup).

const TOKEN_KEY = "addbills.access_token";

function hasStorage(): boolean {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function getToken(): string | null {
  if (!hasStorage()) return null;
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  if (!hasStorage()) return;
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // Quota or privacy mode - swallow so the UI keeps functioning in-memory.
  }
}

export function clearToken(): void {
  if (!hasStorage()) return;
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}
